module.exports = __webpack_public_path__ + "static/track-4-97a3decf531ba8e190cef0aeaa9004ee.jpg";